// extracted by mini-css-extract-plugin
export default {"header":"Header_header__4FYIt","main-image":"Header_main-image__ybQd5"};